import * as React from "react"
import {useEffect} from "react"
import {number, object} from "yup";
import {AutocompleteAjaxSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {BACKEND_APIS} from "@constants";
import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerCustomer() {
	const { localValue, handleChange } = useMatchersSkusForm('customerID')
	const { errors } = useValidatorSeeker({
		customerID: localValue === 'null' ? 0 : (localValue || null)
	}, object({
		customerID: number().required('Customer is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			customerID: errors?.customerID
		}
	}, [errors?.customerID]);

	return <AutocompleteAjaxSeeker
		urlAjax={`${BACKEND_APIS.BRANDS}/crud/customer`}
		label="Customer"
		placeholder="Please select a customer"
		value={localValue || ''}
		onChange={newValue => handleChange(newValue.target.value)}
		error={errors?.customerID}
	/>
}
